import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-text",
  "use": "icon-text-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-text\"><defs><style type=\"text/css\"></style></defs><path d=\"M204.693 552.831h208.002l47.67 125.667h78l-186.336-476.676h-86.667l-186.338 481.011h78l47.67-130.001zM291.36 310.156c4.335-12.997 8.666-25.998 13.002-43.33h4.335c0 4.332 4.332 12.998 12.997 34.665 0 4.335 4.335 8.666 4.335 8.666 0 4.335 25.998 65.005 69.335 186.338h-173.337c47.666-121.337 69.334-182.004 69.334-186.338v0zM291.36 310.156z\" p-id=\"3165\" /><path d=\"M79.023 743.499h866.684v60.668h-866.684v-60.668zM79.023 743.499z\" p-id=\"3166\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/text.svg
// module id = meoi
// module chunks = 31